import { render, staticRenderFns } from "./ManageFile.vue?vue&type=template&id=35c82faf&scoped=true&"
import script from "./ManageFile.vue?vue&type=script&lang=js&"
export * from "./ManageFile.vue?vue&type=script&lang=js&"
import style0 from "./ManageFile.vue?vue&type=style&index=0&id=35c82faf&scoped=true&lang=css&"
import style1 from "./ManageFile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c82faf",
  null
  
)

export default component.exports